<template>
    <layout>
        <template v-slot:title>
            <v-img
                :alt="trans('layout.title')"
                :height="48" :title="trans('layout.title')"
                :width="177" src="/logo.png"
                :contain="true"
                ></v-img>
        </template>
        <template v-slot:header>
            <select-locale class="mx-2"></select-locale>
        </template>
        <slot></slot>
        <template v-slot:footer>
            <div class="text-center ma-2">{{trans('layout.footer')}}</div>
        </template>
    </layout>
</template>
<script>
import AppLayout from "./layout/AppLayout";
import SelectLocale from "./SelectLocale";

export default {
    props: {},
    data() {
        return {};
    },
    computed: {},
    methods: {},
    watch: {},
    filters: {},
    components:{
        SelectLocale,
        layout:AppLayout,
    }
}
</script>
